// This file is generated by pnpm icons:generate. Do not edit.

import {ArrowTopCircle_Stroke2_Corner0_Rounded as CanonicalArrowTopCircle_Stroke2_Corner0_Rounded} from './Arrow'

/** @deprecated Import ArrowTopCircle_Stroke2_Corner0_Rounded from `#/components/icons/Arrow` instead. */
export const ArrowTopCircle_Stroke2_Corner0_Rounded =
  CanonicalArrowTopCircle_Stroke2_Corner0_Rounded
